import { Button } from "@/components/ui/button";
import { Check } from "@phosphor-icons/react";
import { PLAN_STYLE } from "./billingUtils";

export function PlanCard({ plan, isCurrent, isOwner, busy, onUpgrade }) {
  const style = PLAN_STYLE[plan.key] || PLAN_STYLE.personal;
  const Icon = style.icon;
  return (
    <div
      data-testid={`plan-card-${plan.key}`}
      className={`relative bg-zinc-900 border rounded-xl p-6 flex flex-col ${style.accent} ${isCurrent ? style.glow : ""}`}
    >
      {isCurrent && (
        <span className="absolute top-4 right-4 text-[10px] font-mono uppercase tracking-wider text-blue-400 border border-blue-500/30 bg-blue-500/10 rounded-full px-2 py-0.5">
          Current
        </span>
      )}
      <div className="w-10 h-10 rounded-md bg-zinc-800 flex items-center justify-center mb-4">
        <Icon size={20} weight="fill" className="text-zinc-200" />
      </div>
      <h3 className="font-heading text-lg font-bold tracking-tight">{plan.name}</h3>
      <div className="mt-2 flex items-baseline gap-1">
        <span className="font-heading text-3xl font-extrabold">${plan.price.toFixed(0)}</span>
        <span className="text-sm text-zinc-500">/mo</span>
      </div>

      <ul className="mt-6 space-y-3 flex-1">
        <li className="flex items-center gap-2.5 text-sm text-zinc-300">
          <Check size={16} className="text-blue-500 shrink-0" /> {plan.max_machines} {plan.max_machines === 1 ? "machine" : "machines"}
        </li>
        <li className="flex items-center gap-2.5 text-sm text-zinc-300">
          <Check size={16} className="text-blue-500 shrink-0" /> {plan.max_members} team {plan.max_members === 1 ? "member" : "members"}
        </li>
        <li className="flex items-center gap-2.5 text-sm text-zinc-300">
          <Check size={16} className="text-blue-500 shrink-0" /> {plan.max_concurrent} concurrent {plan.max_concurrent === 1 ? "session" : "sessions"}
        </li>
      </ul>

      <div className="mt-6">
        {isCurrent ? (
          <Button disabled className="w-full bg-zinc-800 text-zinc-500 cursor-default">Current plan</Button>
        ) : plan.key === "personal" ? (
          <Button disabled className="w-full bg-zinc-800 text-zinc-500 cursor-default">Free tier</Button>
        ) : (
          <Button
            data-testid={`upgrade-${plan.key}`}
            onClick={() => onUpgrade(plan.key)}
            disabled={busy === plan.key || !isOwner}
            className="w-full bg-blue-600 hover:bg-blue-500"
          >
            {busy === plan.key ? "Redirecting…" : `Upgrade to ${plan.name}`}
          </Button>
        )}
      </div>
    </div>
  );
}
